export default __webpack_public_path__ + "static/media/banner_bg_img_1.1ce166d6.jpg";